import React from 'react';
import { Tag } from 'antd';
import makeModelColorPicker from '../../utils/makeModelColorPicker';

const IntersectionMakeModel = ({ makeModel, ...props }) => (
  <>
    {makeModel?.length &&
      makeModel.map((entry) => {
        const color = makeModelColorPicker(entry);

        return (
          <Tag color={color} key={entry} {...props}>
            {entry === 'GTT' ? 'Opticom' : entry}
          </Tag>
        );
      })}
  </>
);

export default IntersectionMakeModel;
